import EmailOptionsValues from "./EmailOptionsValues";
import EmailForm from "./Forms/EmailForm";
import { Col, Form, Row } from "antd";

export default function Email(): React.ReactElement {
  const [form] = Form.useForm();

  return (
    <Row gutter={[24, 16]}>
      <Col xs={24} lg={16}>
        <EmailForm form={form} />
      </Col>
      <Col xs={24} lg={8}>
        <EmailOptionsValues />
      </Col>
    </Row>
  );
}
